import _styled from '@emotion/styled/base';
import isPropValid from '@emotion/is-prop-valid';
import * as ProgressPrimitive from '@radix-ui/react-progress';
import { SIZE_MAP } from './constants.js';
import { border, motion } from '@hubble/tokens/web';

const getPercentage = (value, min, max) => {
  if (value === undefined || max === undefined || max === 0) {
    return 0;
  }
  const percentage = (value - min) / (max - min) * 100;
  const invertedPercentage = 100 - percentage;
  return Math.min(Math.max(invertedPercentage, 0), 100);
};
const StyledProgressBarRoot = _styled(ProgressPrimitive.Root, {
  shouldForwardProp: prop => isPropValid(prop) && prop !== 'backgroundColor' && prop !== 'size',
  target: "ertf2631"
})("position:relative;overflow:hidden;background:", ({
  theme,
  backgroundColor
}) => backgroundColor || theme.colorScheme.progress.background, ";border-radius:", border.radius.full, ";height:", ({
  size
}) => SIZE_MAP[size] || SIZE_MAP.md, ";transform:translateZ(0);");
const StyledProgressBarIndicator = _styled(ProgressPrimitive.Indicator, {
  shouldForwardProp: prop => isPropValid(prop) && !['value', 'min', 'max', 'foregroundColor'].includes(prop),
  target: "ertf2630"
})("background:", ({
  theme,
  foregroundColor
}) => foregroundColor || theme.colorScheme.progress.foreground, ";border-radius:", border.radius.full, ";width:100%;height:100%;transform:translateX(\n    -", ({
  value,
  min,
  max
}) => getPercentage(value, min, max), "%\n  );transition:transform ", motion.duration.slow, " ", motion.timing.easeInOut, ";");

export { StyledProgressBarIndicator, StyledProgressBarRoot };
